<template>
    <div class="file-card" @click="handleDoubleClick" @contextmenu.prevent="handleContextMenu" :class="{ selected }" @mouseenter="showSelectionCircle = true" @mouseleave="showSelectionCircle = false">
        <div class="selection-circle" v-if="showSelectionCircle || selected" @click.stop="toggleSelection">
            <i class="fas fa-check" v-if="selected"></i>
        </div>
        <div class="file-preview" v-if="isImage">
            <viewer :images="[previewUrl]" v-if="!selectionMode">
                <img :src="previewUrl" :alt="file.name" @click="show" />
            </viewer>
            <img v-else :src="previewUrl" :alt="file.name" />
        </div>
        <div class="file-icon-container" v-else>
            <div class="file-icon">
                <i :class="iconClass"></i>
            </div>
            <div class="file-name">{{ file.name }}</div>
        </div>
        <div
            class="context-menu"
            v-if="showContextMenu"
            :style="{ left: contextMenuPosition.x + 'px', top: contextMenuPosition.y + 'px' }"
        >
            <div class="context-menu-title">{{ $t("message.actions") }}</div>
            <div class="context-menu-item" @click="handleDelete"><i class="fas fa-trash text-danger"></i> {{ $t("message.delete")}}</div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

Vue.use(Viewer);

export default Vue.extend({
    name: "FileCard",
    props: {
        file: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        selectionMode: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hovered: false,
            showContextMenu: false,
            contextMenuPosition: {
                x: 0,
                y: 0,
            },
            showSelectionCircle: false,
        };
    },
    computed: {
        iconClass() {
            if (this.file.isFolder) {
                return "fas fa-folder";
            }

            const mimeType = this.file.asset?.mime;
            if (mimeType?.includes("pdf")) return "fas fa-file-pdf";
            if (mimeType?.includes("word")) return "fas fa-file-word";
            if (mimeType?.includes("excel")) return "fas fa-file-excel";

            return "fas fa-file";
        },
        isImage() {
            const mimeType = this.file.asset?.mime;
            return mimeType?.includes("image");
        },
        previewUrl() {
            // Resim önizleme URL'sini oluşturun
            // Örneğin: `/api/assets/${this.file.asset._id}/preview`
            return this.file.asset?.cdnUrl;
        },
    },
    methods: {
        show() {
            if (!this.selectionMode) {
                this.$el.querySelector(".file-preview img").click();
            }
        },
        handleContextMenu(event) {
            event.preventDefault();
            this.showContextMenu = true;
            this.contextMenuPosition = {
                x: event.clientX,
                y: event.clientY,
            };
        },
        hideContextMenu() {
            this.showContextMenu = false;
        },
        handleDelete() {
            this.$emit("delete", this.file);
            this.hideContextMenu();
        },
        handleDoubleClick() {
            this.$emit("click", this.file);
        },
        toggleSelection() {
            this.$emit('toggleSelection', this.file);
        }
    },
    mounted() {
        document.addEventListener("click", this.hideContextMenu);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.hideContextMenu);
    },
});
</script>

<style scoped lang="scss">
.file-card {
    background: #fff;
    padding: 5px;

    cursor: pointer;
    transition: all 0.2s;
    width: 100px;
    height: 100px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    //&:hover {
    //    transform: translateY(-2px);
    //    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    //    border-radius: 5px;
    //}

    &.selected {
        border: 2px solid #1890ff;
        overflow: hidden;
    }

    .file-preview {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 100px;
        position: relative;

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            cursor: pointer;
        }

        &:hover {
            cursor: pointer;
            filter: grayscale(100%);
        }

        .preview-icon {
            position: absolute;
            pointer-events: none;
            z-index: 2;
        }
    }

    .file-icon-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: max-content;
    }

    .file-icon {
        font-size: 2rem;
        text-align: center;
        margin-bottom: 0.5rem;
        color: #666;
    }

    .file-name {
        text-align: center;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 90px;
    }

    .selection-circle {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: white;
        border: 2px solid #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            border-color: #1890ff;
        }

        .fa-check {
            color: #1890ff;
            font-size: 12px;
        }
    }

    &.selected {
        .selection-circle {
            border-color: #1890ff;
            background-color: #1890ff;

            .fa-check {
                color: white;
            }
        }
    }

    border: 2px solid transparent;

    &.selected {
        border-color: #1890ff;
    }

    .selection-indicator {
        // ...
        display: flex;
        // ...
    }

    .file-preview {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }

    // ...
}

.context-menu {
    position: fixed;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    z-index: 999999;

    .context-menu-title {
        font-weight: bold;
        padding: 8px 16px;
        border-bottom: 1px solid #e0e0e0;
    }

    .context-menu-item {
        display: flex;
        align-items: center;
        padding: 8px 16px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        i {
            margin-right: 8px;
        }

        .text-danger {
            color: #dc3545;
        }
    }
}
</style>
